import { env } from "@/env";
import { FEATURE_FLAGS } from "./featureFlags";
import type { MarketConfiguration } from "./markets/const";

export function isAdyenCheckoutEnabled({
  marketConfig,
}: {
  marketConfig: MarketConfiguration;
}) {
  return marketConfig.adyenCheckoutEnabled && FEATURE_FLAGS.checkout.adyen;
}

export function isWalleyCheckoutEnabled({
  marketConfig,
}: {
  marketConfig: MarketConfiguration;
}) {
  return marketConfig.walleyCheckoutEnabled && FEATURE_FLAGS.checkout.walley;
}

export const GIFTCARD_PAYMENT_METHOD_ID = Number(
  env.NEXT_PUBLIC_GIFT_CARD_PAYMENT_METHOD_ID,
);

export const ADYEN_PAYMENT_METHOD_ID = Number(
  env.NEXT_PUBLIC_ADYEN_PAYMENT_METHOD_ID,
);

const NORCE_CHECKOUT_PAYMENT_METHOD_ID = 239;
export const WALLEY_PAYMENT_METHOD_ID = FEATURE_FLAGS.checkout.v3
  ? NORCE_CHECKOUT_PAYMENT_METHOD_ID
  : Number(env.NEXT_PUBLIC_WALLEY_PAYMENT_METHOD_ID);
